import RestService from "./rest.service";

class handbooksService {
  handbooks() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getHandbooks("app/kpi/support/handbooks").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  

  content(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.getContentHandBook(`app/kpi/support/handbooks/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}



export default new handbooksService();
